export const EmptyPatientsImage = () => (
  <svg width="171" height="141" viewBox="0 0 171 141" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M53.5174 0.196224C87.5782 0.138961 170.276 23.2407 170.324 51.9097C170.372 80.5786 109.222 140.817 75.161 140.874C41.1002 140.931 0.131867 78.7198 0.0836695 50.0508C0.0354717 21.3819 19.4566 0.253487 53.5174 0.196224Z"
      fill="white"
    />
    <path
      d="M29.5724 93.604L46.7828 93.604M98.8052 93.604L58.126 93.604"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.4404 82.2609C48.4451 75.6603 49.3251 71.475 51.672 64.4344C54.0188 57.3937 54.41 53.6774 58.2222 52.1133C60.1933 51.3046 67.094 49.2555 69.8106 48.7681M46.4404 82.2609C52.112 82.2609 59.2993 88.0987 59.2993 88.0987V93.4085M46.4404 82.2609C46.4404 82.2609 47.1738 83.0668 48.0848 83.6819"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M107.41 64.8547C107.41 64.8547 102.913 63.7509 99.7831 64.0724C96.6535 64.3938 92.5469 66.0281 93.3292 70.0654C94.8938 65.4903 105.383 65.2458 106.237 68.1794C106.237 68.1794 105.572 65.573 105.064 64.3938C102.13 55.9842 100.124 53.1846 98.023 52.0727C96.2214 51.1193 86.168 49.0117 86.168 49.0117"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.9124 48.2017C69.6722 50.8461 73.2064 53.4905 77.8126 53.4905C82.4187 53.4905 86.2483 51.0865 86.2483 48.2017"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M97.4362 85.5854C97.4362 88.1768 97.4362 90.6703 97.4362 93.6039"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.5068 123.833C70.5068 123.833 71.6276 124.561 71.0429 125.14C70.5751 125.604 69.6304 125.278 68.4669 124.309C67.1649 123.224 66.8198 123.125 65.4111 121.395C64.0024 119.666 63.0391 118.601 62.5264 117.529C62.6743 117.924 63.1902 119.493 64.1295 120.984C65.0689 122.475 66.3418 123.257 65.6311 124.04C64.9204 124.823 62.4712 122.396 61.6708 120.984C60.8704 119.572 59.9152 118.475 59.5809 116.341C59.2466 114.207 58.7894 112.007 58.7894 112.007C53.9212 104.458 47.2716 96.4891 46.7828 93.3108C46.2939 90.1325 46.4555 89.0367 46.7828 87.737C47.19 86.12 47.771 84.3958 48.3804 82.6133M64.7266 116.608C66.0093 118.504 66.2746 118.923 67.6602 120.838C68.8953 122.544 70.8815 124.11 71.645 124.882C72.4085 125.654 73.5763 126.069 74.1386 125.8C75.1901 125.297 73.4296 124.04 72.9162 123.233M72.9162 123.233C71.9021 122.278 70.3493 120.3 70.3493 120.3C70.3493 120.3 68.2314 117.392 66.8535 115.117M72.9162 123.233C73.6739 123.947 74.5541 124.798 75.092 124.529C75.6298 124.26 75.5359 123.848 74.8408 122.647C74.128 121.414 73.6297 120.907 72.3947 119.2C71.6334 118.149 71.3493 117.446 70.1619 115.93M68.072 113.228C68.072 113.228 68.9745 114.413 70.1619 115.93M70.1619 115.93C71.4437 117.019 72.5418 117.94 73.2829 118.1C74.2093 118.299 74.5896 118.034 74.8408 117.529C75.092 117.024 73.5274 115.93 73.5274 115.93C72.4829 114.982 72.0198 113.903 71.0429 112.886C69.9508 111.748 68.2508 110.793 66.3534 109.829C65.2645 109.275 64.1295 107.967 64.1295 107.967C58.2238 97.8089 59.5809 96.3768 56.3169 90.1327M56.3169 90.1327C55.91 89.3542 55.8507 88.3658 53.1878 88.2749M56.3169 90.1327C56.3169 90.1327 56.4769 88.7909 57.1482 86.759"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.2665 123.6C86.2665 123.6 85.0192 124.463 85.604 125.042C86.0718 125.506 87.2339 124.928 88.4887 124.113C89.9099 123.19 90.8 122.586 91.8134 121.341C92.8269 120.097 93.9591 118.937 94.4717 117.865C94.3238 118.26 93.8377 119.121 92.8157 121.082C91.7938 123.044 90.5421 123.625 91.3489 124.26C92.1557 124.896 94.1911 122.494 94.9915 121.082C95.7919 119.67 96.6373 118.475 96.9716 116.341C97.3058 114.207 97.9014 112.007 97.9014 112.007C102.77 104.459 109.535 95.9795 109.908 93.5552C110.281 91.131 110.133 89.0978 109.806 87.7981C109.439 86.0745 109.036 84.62 108.596 82.7376M92.3147 116.98C91.0321 118.876 89.4227 120.632 88.7491 121.341C87.7308 122.414 86.1166 123.717 85.0173 124.651C83.9179 125.585 82.7437 126.167 82.3526 125.507C81.8695 124.692 83.7913 123.051 84.4656 122.414M90.0287 115.412C88.4886 117.562 86.6551 119.982 86.6551 119.982C86.6551 119.982 85.0211 121.911 84.007 122.867C83.2493 123.58 81.8174 124.303 81.3992 123.722C81.1219 123.337 81.2611 122.906 82.2058 121.889C82.8414 121.204 83.6599 120.197 84.895 118.491C85.6563 117.439 87.4314 114.745 88.6188 113.228C86.6551 113.228 85.8163 115.005 84.2349 116.168C83.9005 116.414 82.7192 116.828 82.0836 116.341C81.448 115.854 81.7169 115.288 81.7169 115.288C82.7614 114.341 83.4887 113.445 84.4656 112.428C85.5577 111.291 87.3641 110.032 89.2271 109.494C90.7976 109.041 92.5613 107.967 92.5613 107.967C98.4671 97.8091 97.1099 96.377 100.374 90.1329M100.374 90.1329C100.374 90.1329 99.9828 87.2725 99.343 84.3878M100.374 90.1329C100.781 89.3544 101.543 88.3236 102.912 88.128"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.0782 19.6075C71.8649 16.6146 73.9676 14.9137 78.0746 17.2607C81.986 14.9139 83.9519 16.2772 86.093 17.8474C89.0267 19.9987 91.3735 20.0848 91.3735 22.9323C91.3735 24.8881 90.7868 25.8659 92.547 27.0394C94.3071 28.2128 97.0451 29.5818 96.8496 32.3198C96.654 35.0579 93.7204 36.2313 94.5027 38.7738C95.285 41.3162 97.6319 41.6888 97.6319 44.6409C97.6319 47.5342 96.2629 49.5303 95.0894 51.0948L86.4842 48.9435C82.7684 48.3568 83.1595 42.8808 83.1595 42.8808C83.1595 42.8808 85.1152 41.3162 86.2887 37.6003C87.5239 33.6888 87.071 29.973 85.5064 27.4305C83.9418 24.8881 79.8348 22.3456 77.879 22.3456C76.1189 22.3456 71.5985 24.7863 70.0561 27.4305C68.5137 30.0747 68.7101 33.6888 69.8605 37.6003C71.011 41.5118 72.7941 42.8808 72.7941 42.8808C72.7941 45.2276 72.9897 47.9657 69.8605 48.9435L65.069 50.1573L61.6464 51.0948C55.5837 41.1206 62.6243 42.2941 62.6243 38.7737C62.6243 35.2534 61.2553 36.0357 61.2553 33.2977C61.2553 29.3862 65.9491 30.0273 65.9491 27.0394C65.9491 25.1178 65.0731 23.4602 65.9491 21.9545C66.825 20.4488 68.3806 20.3567 69.0782 19.6075Z"
      fill="#017C7E"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.953 93.5747L126.577 93.6041"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.2922 36.818C76.8875 36.818 76.3143 36.818 76.3143 36.0357C76.3143 35.2534 77.0966 34.2759 77.0966 33.4933C77.0966 30.9507 76.901 30.1309 76.1187 29.5817C75.0045 28.7994 71.8161 28.6039 70.8383 29.3861"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.6393 29.7774C80.6172 28.7995 83.9419 28.604 84.9198 29.3862"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.8567 36.8181H79.0523"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.0744 38.7739C76.8228 38.7739 75.3364 38.8962 75.3364 39.5562C75.3364 40.2163 76.044 41.1208 77.3478 41.1208H78.8568C80.0302 41.1208 80.8125 40.143 80.8125 39.5562C80.8125 38.9695 79.3261 38.7739 78.0744 38.7739Z"
      fill="#017C7E"
    />
    <path
      d="M80.4218 31.7334C80.8564 32.1245 81.5083 32.5157 82.3775 32.5157C83.1138 32.5157 83.8986 32.1245 84.3332 31.7334"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.7275 31.7334C75.2929 32.1245 74.641 32.5157 73.7718 32.5157C73.0355 32.5157 72.2507 32.1245 71.8161 31.7334"
      stroke="#017C7E"
      strokeWidth="0.586719"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M100.857 69.3501C95.6027 69.8441 95.1248 73.5984 95.2388 74.0273L97.2393 84.5779L97.7294 86.8324C98.2865 89.2742 100.174 88.7148 100.174 88.7148L99.7829 86.5635C99.5623 85.35 99.848 84.6135 100.857 84.021C101.835 83.4468 102.967 83.3186 104.085 83.2387C106.824 83.0432 108.779 83.8255 109.17 85.1945L109.562 86.8324C109.562 86.8324 111.278 85.2515 111.123 84.3812C111.038 83.8993 108.577 72.6738 108.348 72.1603C108.077 71.5499 106.111 68.8561 100.857 69.3501Z"
      fill="black"
      stroke="#017C7E"
      strokeWidth="0.664948"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M103.453 68.6999L98.6233 69.0885L98.6086 69.0869L98.6109 69.0931L96.772 69.7623C96.1715 69.9809 95.824 70.6059 95.9602 71.2304L98.1253 81.4171C98.2903 82.1786 99.0822 82.6206 99.8128 82.3547L100.925 81.9429C101.191 81.846 101.469 81.7801 101.75 81.7621L105.77 81.4432C106.696 81.3661 107.341 80.4994 107.151 79.5925L105.094 69.9142C104.917 69.1572 104.223 68.6374 103.453 68.6999Z"
      fill="black"
      stroke="#017C7E"
      strokeWidth="0.391146"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M103.249 67.735L98.8268 68.0876C98.5482 68.1118 98.2746 68.1693 98.0145 68.2639L96.5618 68.7997C95.9613 69.0183 95.6138 69.6433 95.75 70.2678L97.9151 80.4545C98.0801 81.216 98.872 81.658 99.6026 81.3921L100.715 80.9803C100.981 80.8834 101.258 80.8175 101.539 80.7995L105.56 80.4806C106.486 80.4035 107.131 79.5368 106.941 78.6299L104.884 68.9515C104.719 68.1901 104.019 67.6725 103.249 67.735Z"
      fill="black"
      stroke="#017C7E"
      strokeWidth="0.391146"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M103.948 77.1116C104.05 77.0764 104.104 76.9651 104.069 76.863C104.034 76.7609 103.923 76.7066 103.821 76.7418C103.718 76.7769 103.664 76.8882 103.699 76.9903C103.734 77.0925 103.846 77.1468 103.948 77.1116Z"
      fill="#6DA8FF"
    />
    <path
      d="M108.18 79.2253L106.041 69.1575C107.215 69.7443 108.193 71.7 108.193 71.7C108.193 71.7 109.632 78.0105 110.428 81.5521C110.439 81.5912 110.448 81.6309 110.455 81.6712C110.703 82.7764 110.884 83.5917 110.931 83.8255C111.126 84.8034 110.344 85.7812 110.344 85.7812L108.975 80.1096C108.975 80.1096 108.388 80.1096 108.18 79.2253Z"
      fill="black"
    />
    <path
      d="M110.455 81.6742C110.299 80.7382 108.975 80.1096 108.975 80.1096M108.975 80.1096C108.975 80.1096 108.388 80.1096 108.18 79.2253L106.041 69.1575C107.215 69.7443 108.193 71.7 108.193 71.7C108.193 71.7 110.735 82.8476 110.931 83.8255C111.126 84.8034 110.344 85.7812 110.344 85.7812L108.975 80.1096Z"
      stroke="#017C7E"
      strokeWidth="0.391146"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.7281 106.377C57.6692 105.644 58.8059 105.008 59.6741 104.584"
      stroke="black"
      strokeWidth="0.195573"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.5835 106.017C54.9923 107.122 55.6873 107.844 55.6873 107.844L55.9746 108.272C55.7046 108.489 55.3789 108.376 55.2154 108.192C54.8553 107.789 54.0046 106.48 53.8982 106.107C53.8385 105.898 54.7816 104.116 56.7937 103.039C60.5401 101.035 61.4992 102.085 61.4992 102.085C61.79 102.491 62.2004 103.102 62.4285 103.578C62.5505 103.833 62.8196 104.165 62.4285 104.556C62.2789 104.354 62.1299 103.456 61.2199 103.716C60.1736 104.014 58.9251 104.392 56.5835 106.017Z"
      fill="black"
      stroke="#017C7E"
      strokeWidth="0.195573"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M55.9351 107.074L56.3452 106.736C56.4229 106.672 56.4432 106.561 56.3932 106.474C56.3285 106.361 56.1763 106.335 56.0779 106.421L55.9503 106.532C55.792 106.67 55.5485 106.636 55.4338 106.46L54.6335 105.233C54.5376 105.086 54.5514 104.893 54.6673 104.761L54.824 104.583C54.9015 104.494 54.9004 104.362 54.8214 104.275L54.8139 104.267C54.7546 104.202 54.6616 104.179 54.5793 104.211C54.5523 104.221 54.5275 104.236 54.5084 104.258C54.4126 104.365 54.2562 104.597 54.1435 104.77C54.0592 104.899 54.0624 105.066 54.1489 105.194L55.3622 106.991C55.4913 107.182 55.757 107.221 55.9351 107.074Z"
      fill="#F8F8F8"
      stroke="#017C7E"
      strokeWidth="0.195573"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M60.7645 104.337L60.3062 104.505C60.2018 104.543 60.0849 104.502 60.0278 104.406C59.956 104.286 60.0062 104.131 60.1346 104.075L60.5767 103.884L59.4582 101.959L58.9807 102.095C58.8861 102.122 58.786 102.076 58.7444 101.987C58.6946 101.88 58.7478 101.754 58.8591 101.714L59.3597 101.537C59.54 101.474 59.7399 101.55 59.8324 101.717L60.9722 103.781C61.0882 103.99 60.9896 104.254 60.7645 104.337Z"
      fill="#F8F8F8"
      stroke="#017C7E"
      strokeWidth="0.195573"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
